import Icon from '@admin/components/icon'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

class Content extends React.Component {

  static propTypes = {
    blocks: PropTypes.array,
    config: PropTypes.object
  }

  _handleDragStart = this._handleDragStart.bind(this)

  render() {
    const { blocks } = this.props
    return (
      <div className="designer-content-types">
        { blocks.map((block, index) => (
          <div className="maha-drag-token" key={`type_${index}`} { ...this._getBlockType(block) }>
            <div className="maha-drag-token-icon section">
              <Icon svg={ block.svg } />
            </div>
            <div className="maha-drag-token-label">
              <T text= { block.label } />
            </div>
          </div>
        )) }
      </div>
    )
  }

  _getBlockType(block) {
    return {
      draggable: true,
      onDragStart: this._handleDragStart.bind(this, block)
    }
  }

  _handleDragStart(block, e) {
    e.stopPropagation()
    e.dataTransfer.dropEffect = 'all'
    e.dataTransfer.setData('type', block.type)
  }

}

export default Content
